import {createFileRoute} from '@tanstack/react-router';
import {DiscoverPage} from 'pages/discover/DiscoverPage';
import {DiscoverPageV2} from 'pages/discover/DiscoverPageV2';
import {useFeatureFlags} from 'hooks';

const DiscoverRouter = () => {
  const flags = useFeatureFlags();
  return flags.discoverV2 ? <DiscoverPageV2 /> : <DiscoverPage />;
};

export const Route = createFileRoute('/_protected/home/discover/')({
  component: DiscoverRouter,
  validateSearch: (search) => {
    return {
      tab: search.tab as string | undefined,
    };
  },
});
